import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const IntervalPicker = ({ f, setF, catalog, units }) => (
  <div className="space-y-2 rounded-lg border border-slate-700 bg-slate-950/50 p-3">
    <div className="flex items-center justify-between gap-3">
      <Label htmlFor="ct_own" className="leading-snug">Periodicidade própria para este cliente</Label>
      <Switch id="ct_own" checked={f.own} onCheckedChange={(own) => setF({ ...f, own })} data-testid="contract-own-interval-switch" />
    </div>
    {!f.own ? <p className="text-xs text-slate-400" data-testid="contract-catalog-interval">Segue o catálogo: a cada {catalog}.</p> : (
      <div className="grid grid-cols-2 gap-3">
        <Input type="number" min={1} required value={f.interval_value} onChange={(e) => setF({ ...f, interval_value: e.target.value })} className="h-10 bg-slate-950" data-testid="contract-interval-input" aria-label="Repetir a cada" />
        <Select value={f.interval_unit} onValueChange={(interval_unit) => setF({ ...f, interval_unit })}>
          <SelectTrigger className="h-10 bg-slate-950" data-testid="contract-unit-select"><SelectValue /></SelectTrigger>
          <SelectContent className="border-slate-700 bg-slate-900">
            {Object.entries(units).map(([k, [, plural]]) => <SelectItem key={k} value={k} data-testid={`contract-unit-${k}`}>{plural}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="col-span-2 text-xs text-slate-500">Vale a partir do próximo atendimento marcado como realizado.</p>
      </div>
    )}
  </div>
);

export const ContractStatusPicker = ({ value, onChange, statuses }) => (
  <div className="space-y-1.5">
    <Label>Situação</Label>
    <div className="grid grid-cols-3 gap-2">
      {Object.entries(statuses).map(([k, [label]]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`contract-status-${k}`}
          className={`rounded-lg border px-3 py-2 text-sm font-medium transition-colors duration-150 ${value === k ? "border-slate-100 bg-slate-100 text-slate-900" : "border-slate-700 text-slate-300 hover:border-slate-500"}`}>{label}</button>
      ))}
    </div>
    {value !== "ativo" && <p className="text-xs text-amber-300/90" data-testid="contract-status-hint">Novos retornos não serão agendados automaticamente. Os já agendados continuam no calendário.</p>}
  </div>
);
